import groupApi from './api/groupApi';

export const GROUP_INSERT = 'group/INSERT';
export const GROUP_LIST = 'group/LIST';

const initialState = {
	data: null,
}

export default (state = initialState, action) => {
	switch (action.type) {
		case GROUP_LIST:
			return {
				...state,
				data: action.payload
			};
		default:
			return state;
		
	}
};

export const groupInsert = (payload) => {
	return dispatch => {
		return groupApi.GroupInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const groupUpdate = (payload, id) => {
	return dispatch => {
		return groupApi.GroupUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const groupList = () => {
	return dispatch => {
		return groupApi.GroupList().then(data => {
			dispatch({
				type: GROUP_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const groupDelete = (id) => {
	return dispatch => {
		return groupApi.GroupDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};